import React, { Component } from "react";
import { Modal, Button, Tag } from "tinper-bee";

export default class SubmitModal extends Component<any, any> {
    render() {
        let { show, onConfirm, onCancel, env, tneItem } = this.props;
        let { name, version, type , manifestVersion } = tneItem;
        return (
            <Modal
                dialogClassName="org-select-modal"
                show={show}
                className="demo3-modal"
            >
                <Modal.Header>
                    <Modal.Title>确认是否更改</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p>二方包包名：{name}</p>
                        <p>环境：{env}</p>
                        {
                            manifestVersion &&
                            <p>变更前版本：{manifestVersion}</p>
                        }
                        <p>变更后版本：{version}</p>
                        <p>
                            变更类型：{" "}
                            <Tag colors={type === "add" ? "info" : "success"}>
                                {type === "add" ? "新增" : "更改版本"}
                            </Tag>
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button style={{ marginRight: 20 }} onClick={onCancel}>
                        取消
                    </Button>
                    <Button colors="primary" onClick={onConfirm}>
                        提交
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
